/** Público: espejo de lo que devuelve `backend/src/modules/publico` (publico.service.ts). */

export type Fuente = "base" | "ventas" | "reactivacion" | "whatsapp" | "emails";

export interface Segmento {
  /** los grupos del motor vienen como «m:<segmentacionId>:<grupo>» */
  grupoId: string;
  nombre: string;
  emoji: string;
  campanaActivaId: string;
  /** el nombre del análisis de Reactivación o de la campaña del motor */
  analisis: string;
  analizadoAt: string;
  /** «motor»: el grupo de una segmentación de Nueva campaña, que gana al de un análisis (ausente = Reactivación) */
  origen?: "motor" | "reactivacion";
  segmentacionId?: string;
  /** en el grupo de control de esa campaña: no se le manda nada */
  esControl?: boolean;
}

export interface Compras {
  frecuencia: number;
  montoTotal: number;
  recenciaDias: number | null;
  /** «AAAA-MM-DD»; vacío si nunca compró */
  ultimaCompra: string;
  sucursal: string;
  /** de dónde salen: la base de ventas gana sobre los análisis de las campañas por QR */
  origen?: "ventas" | "reactivacion";
}

export interface ActividadWhatsApp {
  enviados: number;
  entregados: number;
  leidos: number;
  respuestas: number;
  porApi: number;
  porQr: number;
  ultimoEnvioAt: string | null;
  ultimaRespuestaAt: string | null;
}

export interface ActividadMail {
  enviados: number;
  aperturas: number;
  clics: number;
  respuestas: number;
  rebotes: number;
  ultimoEnvioAt: string | null;
  ultimaAperturaAt: string | null;
  ultimaRespuestaAt: string | null;
}

export interface PersonaPublico {
  /** opaca: es lo que va en la URL de la ficha (nunca un celular ni un mail) */
  clave: string;
  nombre: string;
  /** enmascarados */
  telefonos: string[];
  emails: string[];
  etiquetas: string[];
  segmento: Segmento | null;
  compras: Compras | null;
  optIn: boolean | null;
  wa: ActividadWhatsApp;
  mail: ActividadMail;
  baja: { whatsapp: boolean; mail: boolean };
  fuentes: Fuente[];
  ultimaInteraccionAt: string | null;
  baseContactoId: string;
  conversacionId: string;
}

export interface EstadoArmado {
  armadoAt: string | null;
  duracionMs: number;
  personas: number;
  error: string;
  enCurso: boolean;
}

export interface ResumenPublico {
  totales: {
    personas: number;
    conWhatsApp: number;
    conMail: number;
    contactados: number;
    respondieron: number;
    respondieronWa: number;
    abrieronMail: number;
    bajas: number;
  };
  /** «sin» = las personas sin segmento */
  segmentos: { id: string; nombre: string; emoji: string; personas: number }[];
  estado: EstadoArmado;
}

export const ACTIVIDADES = ["respondio", "respondio_wa", "respondio_mail", "abrio_mail", "clic_mail", "contactado", "sin_contactar", "baja"] as const;
export type Actividad = (typeof ACTIVIDADES)[number];
export const CANALES = ["whatsapp", "mail", "ambos", "solo_whatsapp", "solo_mail"] as const;
export type CanalFiltro = (typeof CANALES)[number];
export type Orden = "reciente" | "nombre" | "compras";

export interface FiltrosPublico {
  q?: string;
  segmento?: string;
  canal?: CanalFiltro;
  actividad?: Actividad;
  orden?: Orden;
  pagina?: number;
  porPagina?: number;
}

export interface PaginaPublico {
  total: number;
  pagina: number;
  porPagina: number;
  personas: PersonaPublico[];
}

export type CanalHecho = "whatsapp" | "mail" | "compra";
export interface Hecho {
  at: string;
  canal: CanalHecho;
  via: string;
  tipo: string;
  titulo: string;
  detalle: string;
}

export interface FichaPublico {
  persona: PersonaPublico;
  historial: Hecho[];
}

export interface ExportacionPublico {
  nombre: string;
  contenido: string;
  filas: number;
  recortado: boolean;
}
